import React, { ReactElement } from 'react'
import { MapContainer } from 'react-leaflet'
import { Box, SxProps, Typography } from '@mui/material'
import { theme } from 'index'
import { LatLng } from 'leaflet'
import { omit } from 'ramda'
import { MapInner, MapInnerProps } from 'components/Map/components/MapInner'
import { MapMarkerProps } from 'components/Map/components/MapMarker'
import { MAP_ZOOM_DEFAULT } from 'components/Map/constants'
import { Section } from 'components/Section'
import { LAT_LNG_INITIAL } from 'consts'

export const MAP_ACTIONS_Z_INDEX = 1100
export const MAP_OVERLAY_Z_INDEX = 1101

export interface MarkerData {
  coords: LatLng
  color: MapMarkerProps['color']
  taskID?: number
  content: ReactElement | string
}

export interface MapProps extends MapInnerProps {
  height?: string
  sx?: SxProps
}

export const Map = (props: MapProps) => {
  const { coords, markers, height = '400px', sx } = props

  return (
    <Section
      sx={{
        overflow: 'hidden',
        ...(sx ?? {}),
      }}
      componentProps={{
        content: {
          sx: {
            position: 'relative',
            padding: 0,
          },
        },
        header: { sx: { paddingBottom: '20px' } },
      }}
    >
      {typeof markers !== 'undefined' && markers.length === 0 && (
        <Box
          sx={{
            position: 'absolute',
            zIndex: MAP_OVERLAY_Z_INDEX,
            left: '0',
            top: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            height: '100%',
            textAlign: 'center',
            background: 'rgba(0,0,0,.5)',
          }}
        >
          <Typography
            variant={'h5'}
            color={theme.palette.common.white}
          >
            Нет геометок для задач из списка
          </Typography>
        </Box>
      )}
      <MapContainer
        center={coords ?? markers?.[0]?.coords ?? LAT_LNG_INITIAL}
        zoom={MAP_ZOOM_DEFAULT}
        style={{ height }}
        minZoom={2}
        bounceAtZoomLimits
        scrollWheelZoom
      >
        <MapInner {...omit(['height, sx'], props)} />
      </MapContainer>
    </Section>
  )
}
